var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "properties-field", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _c("h4", { staticClass: "title" }, [_vm._v("Configuration")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: {
                click: function($event) {
                  !_vm.showModalFieldLibrary ? _vm.submitForm(true) : null
                }
              }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "properties-field-content properties-field-content-config"
          },
          [
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c(
                  "b-form",
                  {
                    staticClass: "input-field m__b--14",
                    class: { "error-input": _vm.$v.dataSetup.title.$error }
                  },
                  [
                    _c("label", [_vm._v(" Title ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        "error-required": false,
                        placeholder: "Enter title view"
                      },
                      model: {
                        value: _vm.dataSetup.title,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "title", $$v)
                        },
                        expression: "dataSetup.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Data Source")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("div", { staticClass: "configuration-toggle-in-title" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-option" }, [
                      _c("div", { staticClass: "filter-selected" }, [
                        _vm._v(_vm._s(_vm.dataSetup.filterOperator))
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-chevron-down",
                        on: {
                          click: function($event) {
                            _vm.showFilterOptions = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showFilterOptions
                        ? _c("div", { staticClass: "filter-options" }, [
                            _c("p", [_vm._v("Operator")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-around"
                              },
                              _vm._l(_vm.filterOperatorOptions, function(
                                operator
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: operator.id,
                                    staticClass: "operator-option",
                                    class: {
                                      "operator-selected":
                                        operator.id ===
                                        _vm.dataSetup.filterOperator
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.closeFilterOptions(operator.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(operator.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              })
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "configuration-section-subtitle" }, [
                    _vm._v("By Value")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.filter, function(data, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "div-filter" },
                      [
                        _c("div", { staticClass: "header-filter" }, [
                          _c("div", { staticClass: "index" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash",
                            on: {
                              click: function($event) {
                                _vm.deleteFilter(index)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.variableOptions,
                                placeholder: "Select Column",
                                "value-format": "object",
                                label: "label"
                              },
                              model: {
                                value: data.key,
                                callback: function($$v) {
                                  _vm.$set(data, "key", $$v)
                                },
                                expression: "data.key"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Value ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: {
                                "error-required": false,
                                placeholder: "Input Filter Value"
                              },
                              model: {
                                value: data.value,
                                callback: function($$v) {
                                  _vm.$set(data, "value", $$v)
                                },
                                expression: "data.value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addFilter }
                    },
                    [_vm._v("\n            + Add Parameter\n          ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "separator" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "configuration-section-subtitle" }, [
                    _vm._v("By Function")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.filter_function, function(data, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "div-filter" },
                      [
                        _c("div", { staticClass: "header-filter" }, [
                          _c("div", { staticClass: "index" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash",
                            on: {
                              click: function($event) {
                                _vm.deleteFilterFunction(index)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.variableOptions,
                                placeholder: "Select Column",
                                "value-format": "object",
                                label: "label"
                              },
                              model: {
                                value: data.key,
                                callback: function($$v) {
                                  _vm.$set(data, "key", $$v)
                                },
                                expression: "data.key"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Function ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.listFunction,
                                placeholder: "Select Function",
                                "error-required": false,
                                label: "name"
                              },
                              model: {
                                value: data.value,
                                callback: function($$v) {
                                  _vm.$set(data, "value", $$v)
                                },
                                expression: "data.value"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "separator" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "configuration-toggle-in-title" },
                          [
                            _vm._m(1, true),
                            _vm._v(" "),
                            _c("j-switch", {
                              attrs: { disabled: _vm.isDataset },
                              model: {
                                value: data.skip_null_value,
                                callback: function($$v) {
                                  _vm.$set(data, "skip_null_value", $$v)
                                },
                                expression: "data.skip_null_value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addFilterFunction }
                    },
                    [_vm._v("\n            + Add Parameter\n          ")]
                  )
                ],
                2
              ),
              _vm._v(" "),
              !_vm.isDataset
                ? _c(
                    "div",
                    { staticClass: "configuration-section" },
                    [
                      _c("h4", { staticClass: "configuration-section-title" }, [
                        _vm._v("Sorting")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "configuration-section-desc" }, [
                        _vm._v(
                          "\n            The displayed data can be sorted according to the specified parameters\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          staticClass: "mb-2",
                          class: {
                            "error-input": _vm.$v.dataSetup.sorting.key.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Column ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.variableOptions,
                              placeholder: "Select Column",
                              "error-required": false,
                              "value-format": "object",
                              label: "label"
                            },
                            model: {
                              value: _vm.dataSetup.sorting.key,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup.sorting, "key", $$v)
                              },
                              expression: "dataSetup.sorting.key"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.sorting.order.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Order Type ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.orderOptions,
                              "error-required": false,
                              placeholder: "Select Order Type",
                              "value-format": "object",
                              label: "label"
                            },
                            model: {
                              value: _vm.dataSetup.sorting.order,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup.sorting, "order", $$v)
                              },
                              expression: "dataSetup.sorting.order"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "configuration-section" }, [
                _c(
                  "div",
                  { staticClass: "configuration-toggle-in-title" },
                  [
                    _c("div", { staticClass: "wrap-title" }, [
                      _c("h4", { staticClass: "configuration-section-title" }, [
                        _vm._v("Server Side Pagination")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "configuration-section-desc" }, [
                        _vm._v(
                          "\n                Server-side pagination requests each page individually loaded upon navigation.\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.dataSetup.server_side_pagination &&
                      _vm.sourceType === "external_url"
                        ? _c(
                            "p",
                            { staticClass: "configuration-section-desc" },
                            [
                              _vm._v(
                                "\n                The query params limit & page will be sent automatically to the endpoint that was setup\n                in the API List Data config for handling server side pagination. "
                              ),
                              _c("br"),
                              _vm._v(" Sample :\n              ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataSetup.server_side_pagination &&
                      _vm.sourceType === "external_url"
                        ? _c(
                            "p",
                            { staticClass: "configuration-section-desc-gray" },
                            [
                              _vm._v("https://gateway.sample.io/endpoint/get?"),
                              _c("b", [_vm._v("limit=x&page=x")])
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("j-switch", {
                      attrs: { disabled: _vm.isDataset },
                      model: {
                        value: _vm.dataSetup.server_side_pagination,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "server_side_pagination", $$v)
                        },
                        expression: "dataSetup.server_side_pagination"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.dataSetup.server_side_pagination
                  ? _c("div", { staticClass: "config-information" }, [
                      _vm._m(2)
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Search Options")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("Fields")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "configuration-section-desc" }, [
                    _vm._v(
                      "\n            The field used can be adjusted as needed\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "d-flex flex-wrap",
                      attrs: {
                        options: {
                          animation: 300,
                          handle: ".icon-drag"
                        }
                      },
                      model: {
                        value: _vm.dataSetup.search_options_list,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "search_options_list", $$v)
                        },
                        expression: "dataSetup.search_options_list"
                      }
                    },
                    _vm._l(_vm.dataSetup.search_options_list, function(
                      data,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "field-list",
                          class: {
                            selected:
                              index === _vm.selectedIndexField &&
                              _vm.mode === "search"
                          }
                        },
                        [
                          _c("p", { staticClass: "column-name" }, [
                            _vm._v(_vm._s(data.name))
                          ]),
                          _vm._v(" "),
                          _c("field-preview", { attrs: { column: data } }),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-or-delete" }, [
                            _c("div", { staticClass: "button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit",
                                  on: {
                                    click: function($event) {
                                      _vm.editField(index, "search")
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-pencil-square-o"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "delete",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteField(index, "search")
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: {
                        click: function($event) {
                          _vm.openModalFieldLibrary("search")
                        }
                      }
                    },
                    [_vm._v("\n            + Add Field\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "configuration-section" }, [
                _c(
                  "div",
                  { staticClass: "configuration-toggle-in-title" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("j-switch", {
                      model: {
                        value: _vm.dataSetup.auto_show_search_options_list,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.dataSetup,
                            "auto_show_search_options_list",
                            $$v
                          )
                        },
                        expression: "dataSetup.auto_show_search_options_list"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm.sourceType === "form"
              ? _c("div", { staticClass: "section-field input-field" }, [
                  _c("h4", { staticClass: "title-section" }, [
                    _vm._v("Tag Filter")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "configuration-section" }, [
                    _c(
                      "div",
                      { staticClass: "configuration-toggle-in-title" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("j-toggle", {
                          staticClass: "toggle",
                          model: {
                            value:
                              _vm.dataSetup.config_tag_filter.is_use_tag_filter,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetup.config_tag_filter,
                                "is_use_tag_filter",
                                $$v
                              )
                            },
                            expression:
                              "dataSetup.config_tag_filter.is_use_tag_filter"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.dataSetup.config_tag_filter.is_use_tag_filter
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-form",
                              {
                                staticClass: "mb-2",
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.config_tag_filter
                                      .function_name.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Function ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.listFunction,
                                    placeholder: "Select Function",
                                    "error-required": false,
                                    label: "name"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup.config_tag_filter
                                        .function_name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup.config_tag_filter,
                                        "function_name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.config_tag_filter.function_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.config_tag_filter.style
                                      .$error
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "configuration-section-title"
                                  },
                                  [_vm._v(" Style ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "configuration-section-desc" },
                                  [
                                    _vm._v(
                                      " Select the type of style for tag filter "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "div-summary-list-type mt-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "type",
                                        class: {
                                          "type--active":
                                            _vm.dataSetup.config_tag_filter
                                              .style === "button"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.dataSetup.config_tag_filter.style =
                                              "button"
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Button Style\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "type",
                                        class: {
                                          "type--active":
                                            _vm.dataSetup.config_tag_filter
                                              .style === "tab"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.dataSetup.config_tag_filter.style =
                                              "tab"
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Tab Style\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c("h4", { staticClass: "title-section" }, [_vm._v("Others")]),
                _vm._v(" "),
                _vm.sourceType !== "dataset"
                  ? [
                      _vm.type === "default" || _vm.type === "requestor"
                        ? _c(
                            "div",
                            { staticClass: "configuration-section" },
                            [
                              _c(
                                "h4",
                                { staticClass: "configuration-section-title" },
                                [_vm._v("Bulk Actions")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "configuration-section-desc" },
                                [
                                  _vm._v(
                                    "\n              It's a faster action than a row by row operation, but this is best used when execute limited rows.\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form", [
                                _c("div", [
                                  _vm.type === "default"
                                    ? _c(
                                        "div",
                                        { staticClass: "div-input-location" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Action Update")
                                          ]),
                                          _vm._v(" "),
                                          _c("j-switch", {
                                            model: {
                                              value:
                                                _vm.dataSetup
                                                  .is_use_bulking_update,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup,
                                                  "is_use_bulking_update",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.is_use_bulking_update"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.dataSetup.is_use_bulking_update
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.dataSetup.column_bulking_update,
                                          function(data, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "field-list",
                                                class: {
                                                  selected:
                                                    index ===
                                                      _vm.selectedIndexField &&
                                                    _vm.mode === "bulk"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "column-name ml-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.name ||
                                                          "Field Name"
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("field-preview", {
                                                  attrs: {
                                                    "use-drag-icon": false,
                                                    column: data
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "edit-or-delete"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "button" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "edit",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.editField(
                                                                  0,
                                                                  "bulk"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-pencil-square-o"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.deleteField(
                                                                  0,
                                                                  "bulk"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.sourceType === "form"
                                    ? _c(
                                        "div",
                                        { staticClass: "div-input-location" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Action Delete")
                                          ]),
                                          _vm._v(" "),
                                          _c("j-switch", {
                                            model: {
                                              value:
                                                _vm.dataSetup
                                                  .is_use_bulking_delete,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup,
                                                  "is_use_bulking_delete",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.is_use_bulking_delete"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type === "requestor" || _vm.type === "approver"
                        ? _c("div", { staticClass: "configuration-section" }, [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _c("div", { staticClass: "wrap-title" }, [
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "configuration-section-title"
                                    },
                                    [_vm._v("Hide Checkbox")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "configuration-section-desc"
                                    },
                                    [
                                      _vm._v(
                                        "Allows to disable bulk action " +
                                          _vm._s(
                                            _vm.type === "approver"
                                              ? "approval"
                                              : _vm.type
                                          )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value: _vm.dataSetup.isHideCheckbox,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "isHideCheckbox",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.isHideCheckbox"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sourceType === "form"
                        ? _c(
                            "div",
                            { staticClass: "configuration-section" },
                            [
                              _c(
                                "h4",
                                { staticClass: "configuration-section-title" },
                                [_vm._v("Preview Data")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "configuration-section-desc" },
                                [
                                  _vm._v(
                                    "\n              Configuration to show preview data before execute bulk actions\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form", [
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [
                                      _vm._v("Summary of Selected Data")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value:
                                          _vm.dataSetup.config_preview_data
                                            .is_show_summary_data,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup.config_preview_data,
                                            "is_show_summary_data",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.config_preview_data.is_show_summary_data"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.dataSetup.config_preview_data
                                  .is_show_summary_data
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-form",
                                          {
                                            staticClass: "m__b--14",
                                            class: {
                                              "error-input":
                                                _vm.$v.dataSetup
                                                  .config_preview_data
                                                  .summary_label.$error
                                            }
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(" Summary Label ")
                                            ]),
                                            _vm._v(" "),
                                            _c("j-input", {
                                              attrs: {
                                                "error-required": false,
                                                placeholder:
                                                  "Enter summary label"
                                              },
                                              model: {
                                                value:
                                                  _vm.dataSetup
                                                    .config_preview_data
                                                    .summary_label,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dataSetup
                                                      .config_preview_data,
                                                    "summary_label",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataSetup.config_preview_data.summary_label"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "field-list" },
                                          [
                                            _c(
                                              "b-form",
                                              {
                                                class: {
                                                  "error-input":
                                                    _vm.$v.dataSetup
                                                      .config_preview_data
                                                      .summary_data.$error
                                                }
                                              },
                                              [
                                                _c("label", [_vm._v("column")]),
                                                _vm._v(" "),
                                                _c("j-single-select", {
                                                  attrs: {
                                                    "error-required": false,
                                                    options:
                                                      _vm.summaryDataOptions,
                                                    label: "label",
                                                    placeholder:
                                                      "Select Column of Data"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dataSetup
                                                        .config_preview_data
                                                        .summary_data,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dataSetup
                                                          .config_preview_data,
                                                        "summary_data",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dataSetup.config_preview_data.summary_data"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [
                                      _vm._v("List of Selected Data")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value:
                                          _vm.dataSetup.config_preview_data
                                            .is_show_summary_list,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup.config_preview_data,
                                            "is_show_summary_list",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.config_preview_data.is_show_summary_list"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.dataSetup.config_preview_data
                                  .is_show_summary_list
                                  ? _c(
                                      "div",
                                      { staticClass: "div-summary-list" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Define column of table to show selected data list. By default table view config or custom column."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "div-summary-list-type"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "type",
                                                class: {
                                                  "type--active":
                                                    _vm.dataSetup
                                                      .config_preview_data
                                                      .summary_list_type ===
                                                    "by_default"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.setSummaryListType(
                                                      "by_default"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    By Default\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "type",
                                                class: {
                                                  "type--active":
                                                    _vm.dataSetup
                                                      .config_preview_data
                                                      .summary_list_type ===
                                                    "custom"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.setSummaryListType(
                                                      "custom"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Custom\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dataSetup.config_preview_data
                                  .is_show_summary_list &&
                                _vm.dataSetup.config_preview_data
                                  .summary_list_type === "custom"
                                  ? _c(
                                      "div",
                                      { staticClass: "div-summary-list" },
                                      [
                                        _vm.dataSetup.config_preview_data
                                          .summary_list
                                          ? _c(
                                              "draggable",
                                              {
                                                attrs: {
                                                  options: {
                                                    animation: 300,
                                                    handle: ".icon-drag"
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataSetup
                                                      .config_preview_data
                                                      .summary_list,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dataSetup
                                                        .config_preview_data,
                                                      "summary_list",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataSetup.config_preview_data.summary_list"
                                                }
                                              },
                                              _vm._l(
                                                _vm.dataSetup
                                                  .config_preview_data
                                                  .summary_list,
                                                function(data, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "field-list"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center"
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "icon-drag",
                                                            attrs: {
                                                              src: require("@/assets/new-form-ui/dragged.svg")
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-row",
                                                            {
                                                              staticClass:
                                                                "w-100 py-1"
                                                            },
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    md: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "summary-list-column"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          data.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    md: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "summary-list-column"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          data.key
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "edit-or-delete"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "button"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "edit",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.openConfigColumn(
                                                                        data,
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-pencil-square-o"
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "delete",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.deleteColumnSummary(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-trash"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.dataSetup
                                                    .config_preview_data
                                                    .summary_list.length === 0,
                                                expression:
                                                  "dataSetup.config_preview_data.summary_list.length === 0"
                                              }
                                            ],
                                            staticClass: "field-list",
                                            class: {
                                              "error-input":
                                                _vm.$v.dataSetup
                                                  .config_preview_data
                                                  .summary_list.$error
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-drag",
                                                  attrs: {
                                                    src: require("@/assets/new-form-ui/dragged.svg")
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  { staticClass: "w-100" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Column_name")
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Column_key")
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "edit-or-delete" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "button" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "edit",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.openConfigColumn(
                                                              null,
                                                              null
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-pencil-square-o"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn-add-config",
                                            on: {
                                              click: function($event) {
                                                _vm.openConfigColumn(null, null)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "plus-icon" },
                                              [_vm._v("+")]
                                            ),
                                            _vm._v(
                                              "\n                  Add Column\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "configuration-section" }, [
                        _c(
                          "div",
                          { staticClass: "configuration-toggle-in-title" },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("j-toggle", {
                              staticClass: "toggle",
                              model: {
                                value: _vm.dataSetup.row_expansion,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "row_expansion", $$v)
                                },
                                expression: "dataSetup.row_expansion"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "configuration-section" },
                  [
                    _c("h4", { staticClass: "configuration-section-title" }, [
                      _vm._v("Rows Per Page")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "configuration-section-desc" }, [
                      _vm._v(
                        "Option list for total rows per page  as a default, and the maximum limit that can be applied per page is 10,000 records."
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isErrorRowPerPage
                      ? _c("div", { staticClass: "error-required-container" }, [
                          _c("div", { staticClass: "title-error" }, [
                            _vm._v("ERROR")
                          ]),
                          _vm._v(
                            "\n            Please select one option to set as the default for the total number of rows displayed on initial load\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.dataSetup.rows_page_option, function(
                      option,
                      index
                    ) {
                      return _c("div", { key: index }, [
                        _c(
                          "div",
                          {
                            staticClass: "div-row-page-option",
                            class: {
                              "error-input":
                                _vm.dataSetup.rows_page_option.length > 0 &&
                                _vm.$v.dataSetup.rows_page_option.$each[index]
                                  .$error
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dataSetup.rows_page_default,
                                  expression: "dataSetup.rows_page_default"
                                }
                              ],
                              attrs: {
                                id: option,
                                disabled: option === "",
                                type: "radio"
                              },
                              domProps: {
                                value: option,
                                checked: _vm._q(
                                  _vm.dataSetup.rows_page_default,
                                  option
                                )
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "rows_page_default",
                                    option
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dataSetup.rows_page_option[index],
                                  expression:
                                    "dataSetup.rows_page_option[index]"
                                }
                              ],
                              attrs: { type: "number", placeholder: "Option" },
                              domProps: {
                                value: _vm.dataSetup.rows_page_option[index]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.dataSetup.rows_page_option,
                                    index,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-trash cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.deleteRowPageOption(index)
                                }
                              }
                            })
                          ]
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-add-config",
                        on: { click: _vm.addRowPageOption }
                      },
                      [_vm._v("\n            + Add Option\n          ")]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "configuration-section" }, [
                  _c(
                    "div",
                    { staticClass: "configuration-toggle-in-title" },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("j-toggle", {
                        staticClass: "toggle",
                        model: {
                          value: _vm.dataSetup.freeze_header_table,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "freeze_header_table", $$v)
                          },
                          expression: "dataSetup.freeze_header_table"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "configuration-section" }, [
                  _c(
                    "div",
                    { staticClass: "configuration-toggle-in-title" },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("j-toggle", {
                        staticClass: "toggle",
                        model: {
                          value: _vm.dataSetup.disable_redirect_detail_page,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dataSetup,
                              "disable_redirect_detail_page",
                              $$v
                            )
                          },
                          expression: "dataSetup.disable_redirect_detail_page"
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "properties-field-button",
            class: { "justify-content-end": !_vm.isHaveConfiguration }
          },
          [
            _vm.isHaveConfiguration && _vm.type !== "default"
              ? _c(
                  "button",
                  {
                    staticClass: "button-border",
                    attrs: { disabled: _vm.showModalFieldLibrary },
                    on: { click: _vm.deleteView }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete\n      ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  attrs: { disabled: _vm.showModalFieldLibrary },
                  on: {
                    click: function($event) {
                      _vm.submitForm(true)
                    }
                  }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-blue",
                  attrs: { disabled: _vm.showModalFieldLibrary },
                  on: {
                    click: function($event) {
                      _vm.submitForm(false)
                    }
                  }
                },
                [_vm._v("\n          Apply\n        ")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.selectedField
        ? _c("properties-field", {
            ref: _vm.idProperties,
            attrs: {
              id: [_vm.idProperties],
              "field-detail": _vm.selectedField,
              "variable-options": _vm.variables,
              "field-ui-key": _vm.dataSetup.search_options_list,
              "is-group": true,
              "is-new-field": _vm.isNewFieldGroup
            },
            on: {
              "delete-field": function($event) {
                _vm.deleteField(_vm.selectedIndexField, _vm.mode)
              },
              "close-properties": function($event) {
                _vm.togglePropertiesField(false)
              },
              "submit-mode": _vm.submitField
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigColumn
        ? _c("column-configuration", {
            ref: _vm.idConfigColumnSummary,
            attrs: {
              id: _vm.idConfigColumnSummary,
              "field-detail": _vm.selectedColumn,
              "select-variable": _vm.variableOptionsColumn,
              "is-group": true,
              type: "summary"
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfigurationColumn(false)
              },
              "submit-configuration": _vm.submitColumnSummary,
              "delete-configuration": _vm.deleteColumnSummary
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Filter")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Filter data according to the parameters\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Skip Null Value")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                  If the value of a column filter is null, then the filter will be skipped.\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("If you choose to set "),
      _c("b", [_vm._v("Server Side Pagination")]),
      _vm._v(" to "),
      _c("span", { staticClass: "text-red" }, [_vm._v("false")]),
      _vm._v(", it will switch to "),
      _c("b", [_vm._v("Client Side Pagination")]),
      _vm._v(" mode and load only 10,000 records")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Show Search Field")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Field will be show on table view without click button filter\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Dynamic Tag Filter")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v("Tag will be show on table view to represent grouping data")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Row Expansion")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v("Expanding row makes it easier for users to read data")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Freeze Header Table")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "Prevents the row headers of a table from scrolling out of view while examining extensive data"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Disable Redirect To Detail Page")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "When you click on a table row, you will remain on the same page and will not be redirected to a detail page"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-349361a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349361a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/TableConfiguration.vue
// module id = null
// module chunks = 